import { Injectable } from '@angular/core';

import { TokenService } from '@app/core/services/token.service';
import * as fromRoot from '@app/reducers';
import { select, Store } from '@ngrx/store';
import { Observable, ReplaySubject } from 'rxjs';
import { distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { AccountActions } from '@app/core/actions';

@Injectable({
  providedIn: 'root'
})
export class IsAccountPremiumGuard {

  constructor(
    private store$: Store<fromRoot.State>,
    private tokenService: TokenService) {
  }

  canActivate(): Observable<boolean> {
    return this.isAccountPremium().pipe(map((accountIsPremium: boolean) => {
      return accountIsPremium;
    }));
  }

  isAccountPremium(): Observable<boolean> {
    const isAccountPremium$ = new ReplaySubject<boolean>();
    this.store$.pipe(
      select(fromRoot.getToken),
      distinctUntilChanged(),
      takeUntil(isAccountPremium$),
    ).subscribe((token: string) => {
      if (token) {
        if (this.tokenService.isAnonymousAccount(token)) {
          isAccountPremium$.next(false);
        } else {
          if (this.tokenService.isTokenExpired(token)) {
            this.store$.dispatch(AccountActions.refreshToken());
          } else {
            isAccountPremium$.next(true);
          }
        }
      } else {
        isAccountPremium$.next(false);
      }
    });
    return isAccountPremium$.asObservable();
  }
}
